import { useState } from "react";
import config from "../../../config";
import { RxCross1 } from "react-icons/rx";
import MediaSection from "./Comp/MediaSection";
import DocumentSection from "./Comp/DocumentSection";
import { toast } from "react-toastify";
import MediaShareModal from "./Comp/MediaShareModal";
import PropertyDetail from "./Comp/PropertyDetail";
import { showErrorToast, showSuccessToast } from "../../../pages/utils";
import { RiCollapseDiagonalFill, RiExpandDiagonalLine } from "react-icons/ri";
import { saveAs } from "file-saver";

export const MediaDocumentModal = ({ onConfirm, onCancel, shareFile, property, sharedDocuments }) => {
    const [selectedTab, setSelectedTab] = useState("media");
    const [selectedImages, setSelectedImages] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState([]);
    const [shareModalOpen, setShareModalOpen] = useState(false);
    const [imageArray, setImageArray] = useState(shareFile.filter((item) => item.media.split(".")[1] !== "pdf"));
    const [docArray, setDocArray] = useState(sharedDocuments);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);
    console.log("shareFile", selectedDoc);
    const donwloadDocuments = async (fileUrl, filename) => {
        console.log("File url----", fileUrl);

        const accessToken = localStorage.getItem("authUser");
        const token = accessToken?.replace(/^"|"$/g, "");

        try {
            const response = await fetch(fileUrl, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`, // 👈 Include token
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);

            showSuccessToast("File downloaded successfully!");
        } catch (error) {
            console.error("Error downloading file:", error);
            showErrorToast("Failed to download file. Please try again.");
        }
    };

    const downloadImage = async (url, filename = "downloaded-image.jpg") => {
        try {
            const response = await fetch(url);
            // Check if the response is OK (status 200-299)
            if (!response.ok) {
                throw new Error(`Failed to fetch: ${response.statusText}`);
            }

            const blob = await response.blob(); // Convert the image to a Blob
            const blobUrl = URL.createObjectURL(blob); // Create an object URL for the Blob

            // Create a temporary link element
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = filename; // Set the filename for download

            // Trigger the download
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up by revoking the Blob URL
            URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Error downloading the image:", error);
        }
    };

    const handleDownload = () => {
        if (selectedTab === "media") {
            selectedImages.forEach((index) => {
                const file = imageArray[index];
                try {
                    if (file && file.media) {
                        const filenameWithExtension = file.media.split("/").pop();
                        const filenameParts = filenameWithExtension.split("_");
                        const filenameOnly =
                            filenameParts.length > 1 ? filenameParts.slice(1).join("_").split(".")[0] : filenameWithExtension.split(".")[0];
                        const fileExtension = filenameWithExtension.split(".").pop().toLowerCase();
                        const fullFilename = `${filenameOnly}.${fileExtension}`;
                        downloadImage(`${config.get("IMAGE_BASE_URL")}${file.media}`);
                    } else {
                        console.error("File not found or media URL is invalid.");
                    }
                } catch (error) {
                    console.error("Error downloading the image:", error);
                }
            });
        } else if (selectedTab === "document") {
            selectedDoc.forEach((index) => {
                const file = docArray[index];
                if (file && file.media) {
                    const filenameWithExtension = file.message.split("/").pop();
                    const filenameParts = filenameWithExtension.split("_");
                    const filenameOnly =
                        filenameParts.length > 1 ? filenameParts.slice(1).join("_").split(".")[0] : filenameWithExtension.split(".")[0];
                    const fileExtension = filenameWithExtension.split(".").pop().toLowerCase();
                    const fullFilename = `${filenameOnly}.${fileExtension}`;

                    donwloadDocuments(`https://admin.onmls.com/api${file.media}`, fullFilename);
                } else {
                    console.error("File not found or media URL is invalid.");
                }
            });
        }
    };

    const handleShareClick = () => {
        if (selectedTab === "media") {
            const files = selectedImages.map((index) => imageArray[index]);
            if (files.length === 0) {
                showErrorToast("Please select at least one media file to share.");
                return;
            }

            // Set the selected file with its determined file URL
            setSelectedFiles(files.map((file) => ({ ...file, fileUrl: `${config.get("IMAGE_BASE_URL")}${file.media}` })));
            setShareModalOpen(true);
        } else if (selectedTab === "document") {
            const files = selectedDoc.map((index) => docArray[index]);

            if (files.length === 0) {
                showErrorToast("Please select at least one document to share.");
                return;
            }

            // Set the selected file with its determined file URL
            setSelectedFiles(files.map((file) => ({ ...file, fileUrl: `${config.get("IMAGE_BASE_URL")}${file.media}` })));
            setShareModalOpen(true);
        }
    };

    const handleCloseModal = () => {
        setShareModalOpen(false);
    };
    const handleTabChange = (val) => {
        setSelectedTab(val);
        setSelectedDoc([]);
        setSelectedImages([]);
    };

    return (
        <>
            <div
                className={`tw-fixed tw-overflow-y-auto  tw-gap-4 tw-z-[999] ${isExpanded ? "tw-inset-0 tw-py-[120px] " : "tw-right-[12px] tw-top-[120px] tw-h-[600px]"} tw-flex tw-shadow-xl tw-rounded-md tw-justify-center tw-bg-black/50`}
            >
                <div
                    className={`tw-bg-white tw-p-6 tw-overflow-auto ${isExpanded ? "lg:tw-w-[900px]" : "lg:tw-w-[500px]"} tw-w-full   tw-scrollbar-hide tw-rounded-lg tw-shadow-lg tw-shadow-black/20 tw-text-center`}
                >
                    <div className="tw-flex tw-w-full tw-justify-between tw-items-center tw-border-b">
                        <div className={`${!isExpanded ? "tw-text-[12px]" : ""} tw-p-5 lg:tw-px-0 tw-flex tw-gap-5 tw-w-full tw-max-w-6xl`}>
                            <button
                                onClick={() => handleTabChange("media")}
                                className={`tw-px-5 tw-py-1 ${selectedTab === "media" && "tw-bg-background_color"} `}
                            >
                                Media
                            </button>
                            <button
                                onClick={() => handleTabChange("document")}
                                className={`tw-px-5 tw-py-1 ${selectedTab === "document" && "tw-bg-background_color"} `}
                            >
                                Documents
                            </button>
                            {property && (
                                <button
                                    onClick={() => handleTabChange("property")}
                                    className={`tw-px-5 tw-py-1 ${selectedTab === "property" && "tw-bg-background_color"}`}
                                >
                                    Property Details
                                </button>
                            )}
                        </div>

                        {selectedImages.length > 0 || selectedDoc.length > 0 ? (
                            <div className="tw-flex tw-gap-4">
                                <i className="fi fi-rs-download" onClick={handleDownload}></i>
                                <i className="fi fi-rr-share" onClick={handleShareClick}></i>
                            </div>
                        ) : (
                            <div className="tw-flex tw-items-center tw-gap-5">
                                <button
                                    onClick={() => setIsExpanded(!isExpanded)}
                                    className="tw-right-0 tw-bg-background_color tw-h-fit tw-p-[7px] tw-rounded-full tw-text-light_text hover:tw-text-dark_text"
                                >
                                    {isExpanded ? <RiCollapseDiagonalFill /> : <RiExpandDiagonalLine />}
                                </button>
                                <button
                                    onClick={onCancel}
                                    className="tw-right-0 tw-bg-background_color tw-h-fit tw-p-[7px] tw-rounded-full tw-text-light_text hover:tw-text-dark_text"
                                >
                                    <RxCross1 />
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="tw-h-full">
                        {selectedTab === "media" && (
                            <MediaSection imageArray={imageArray} selectedImages={selectedImages} setSelectedImages={setSelectedImages} />
                        )}
                        {selectedTab === "document" && (
                            <DocumentSection
                                docArray={docArray}
                                selectedFiles={selectedDoc}
                                isExpanded={isExpanded}
                                setSelectedFiles={setSelectedDoc}
                            />
                        )}
                        {selectedTab === "property" && <PropertyDetail property={property} isChatScreen={isExpanded ? false : true} />}
                    </div>
                </div>
            </div>
            {shareModalOpen && <MediaShareModal selectedFile={selectedFiles} onClose={handleCloseModal} property={property} />}
        </>
    );
};
